import copy from 'copy-to-clipboard';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDescriptionEditor } from '@widgets/shared/descriptionEditor/model.ts';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { useProgramQuery } from '@src/api/api-hooks/programs/useProgramQuery.ts';
import { useClient } from '@src/entities/clients';
import useWindowDimensions from '@src/library/hooks/common/useWindowDimensions';
import { programsService } from 'library/api/programsService';
import { useAppDispatch } from 'library/hooks/common';
import { showPopup } from 'library/redux/modal';
import { useRecommendModal } from './use-recommend-modal';

interface FormValues {
  comment: string;
  days_period: number;
  link: string;
}

const hash = 'ModalRecommendHash';

export const useFormRecommend = () => {
  const dispatch = useAppDispatch();
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const { clearStorage: clearDescriptionValue } = useDescriptionEditor(hash);

  ///
  ///  recommed для приглашения конкретного клиента, поэтому пока clientId = ''
  ///
  const clientId = '';
  const { module } = useModuleByCodeParam();
  const [step, setStep] = useState<number>(1);
  const { width } = useWindowDimensions();
  const isClients = module?.module_type === 'clients';
  const showCloseBtn = width <= 600;
  const [linkCopy, setLinkCopy] = useState('');
  const { recommendation, toggleRecommendModal } = useRecommendModal();

  const { data: program } = useProgramQuery({ id: recommendation?.programId });

  const { client } = useClient(parseInt(clientId));

  const methods = useForm<FormValues>({ defaultValues: { days_period: 7 } });
  methods.watch('days_period');

  const onCopy = (textToCopy?: string) => {
    copy(textToCopy || linkCopy);
    // dispatch(showPopup({ type: 'message', text: 'Скопировано в буфер обмена' }));
    setIsLinkCopied(true);
  };

  const onClose = () => {
    toggleRecommendModal();
    setIsLinkCopied(false);
    setStep(1);
    clearDescriptionValue();
    methods.reset();
  };

  const invite = async (data: FormValues) => {
    const invite = {
      // days: data.days_period ?? 28,
      days: 7,
      recommendation_comment: data.comment?.length > 0 ? data.comment : undefined,
      link: '',
    };

    try {
      /**
       * Для копирования ссылки в буфер обмена используем конструктор new ClipboardItem,
       * иначе safari вернет NotAllowedError
       */
      const makeHashPromise = async () => {
        const id = recommendation.programId ?? '';
        const response = await programsService.inviteToProgram(id, invite);
        // return await `${window.location.origin}/programs/${code && code.split("/")[0]}/subscribe/${id}/${response.data.hashcode}`;
        return `${window.location.origin}/programs/library/program/recommended/${response.data.hashcode}`;
      };

      const link = await makeHashPromise();
      methods.setValue('link', link);
      setLinkCopy(link);
      setStep(2);
    } catch (error) {
      console.error(error);
      dispatch(showPopup({ type: 'error', text: 'Не удалось сгенерировать ссылку' }));
    }
  };

  const recommend = async (data: FormValues) => {
    if (!client?.user.id) {
      return;
    }

    const recommend = {
      // days_period: data.days_period ?? 28,
      days_period: 7,
      recommendation_comment: data.comment?.length > 0 ? data.comment : undefined,
      program: recommendation.programId ?? '',
      user: client?.user.id,
    };

    try {
      const res = await programsService.recommend(recommend);

      if (!res.data) throw res;

      onClose();
      dispatch(showPopup({ type: 'success', text: 'Программа рекомендована Вашему клиенту' }));
    } catch (error) {
      console.error(error);
    }
  };

  const getRecommendAction = (data: FormValues) => {
    if (isClients) {
      recommend(data);
    } else {
      invite(data);
    }
  };

  return {
    getRecommendAction,
    step,
    setStep,
    isClients,
    methods,
    showCloseBtn,
    onCopy,
    onClose,
    linkCopy,
    setValue: methods.setValue,
    programName: program?.title,
    hash,
    setIsLinkCopied,
    isLinkCopied,
  };
};
